module.exports = __webpack_public_path__ + "static/media/e25.6d5f5ffb.jpg";